import { AGENTIC_AI_AGENT_TOPIC } from "@/components/agenticAI/constants";
import { getErrorMessage } from "@/helpers/handleErrorResponse";
import {
  ConversationsPage,
  GetConversationsParams
} from "@/types/conversations";
import { CustomError } from "@/utils/errors";

import axiosInstance from "../config";

export const getConversations = async (
  { q }: GetConversationsParams,
  cursor?: string
): Promise<ConversationsPage> => {
  const trimmedQuery = q?.trim();

  try {
    const { data } = await axiosInstance.get("/v1/conversations", {
      params: {
        topic: AGENTIC_AI_AGENT_TOPIC,
        ...(trimmedQuery ? { q: trimmedQuery } : {}),
        ...(cursor ? { cursor } : {})
      }
    });
    return data;
  } catch (error) {
    const { status, message } = getErrorMessage(error);
    throw new CustomError(message, status);
  }
};
